<template>
  <div class="content">
    <offline @detected-condition="handleConnectivityChange"></offline>
    <transition name="fade" mode="out-in">
      <!-- your content here -->
      <div>
        <div v-show="routerViewDisplay == true">
          <router-view></router-view>
        </div>
        <div v-show="offlineDisplay == true" class="card col-md-12">
          <img class="center" v-bind:src="wifi_error_image" alt="">
        </div>
      </div>
    </transition>
  </div>
  
</template>
<script>
  import Vue from 'vue';
  import offline from 'v-offline';
  Vue.use(offline);
  export default {
    components: {
      offline
  },
  data() {
    return {
      offlineDisplay: false,
      routerViewDisplay: true,
      wifi_error_image: process.env.VUE_APP_BASE_ROUTE+'img/wifi_error.png',
    };
  },
  methods: {
    // Función que verifica si hay internet y muestra el mensaje permanente
    handleConnectivityChange(status) {
      if(status == false)
      {
        this.offlineDisplay = true;
        this.routerViewDisplay = false;
      }
      else
      {
        this.offlineDisplay = false;
        this.routerViewDisplay = true;
      }
    },
  },
  }
</script>
<style>
  .center {
    padding: 3em 1.5em;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
